import React from "react";

function KeySkills() {
  const skillsList = [
    "Leadership & Strategy: Proven ability to lead large, cross-functional teams and establish strategic technology roadmaps",
    "Digital & Data Transformation: Experienced in cloud-based technologies, serverless infrastructure, and data analytics",
    "Vendor & Stakeholder Management: Skilled in negotiation, establishing governance, and ensuring timely, quality deliverables",
    "Process Improvement: Adept at identifying inefficiencies and implementing agile, automated solutions that reduce costs and increase efficiency",
    "Agile / DevOps: Established agile frameworks, automated pipelines, shift-left security practices, and continuous improvement methodologies",
    "Risk, Compliance & Security: Deep experience in implementing internal penetration testing, security scanning, and compliance best practices",
  ];

  return (
    <ul>
      {skillsList.map((skill, index) => (
        <li key={index} style={{ margin: "8px 0" }}>
          {skill}
        </li>
      ))}
    </ul>
  );
}

export default KeySkills;
